@switch (status) {
    @case (PlaybookGuidelineStatusEnum.MET) {
        <span class="timeline-point timeline-point-indicator timeline-point-success"
              [ngClass]="{'is-loading': processing}"></span>
    }
    @case (PlaybookGuidelineStatusEnum.NOT_MET) {
        <span class="timeline-point timeline-point-indicator timeline-point-danger"
              [ngClass]="{'is-loading': processing}"></span>
    }
    @case (PlaybookGuidelineStatusEnum.FAILED) {
        <span class="timeline-point timeline-point-indicator timeline-point-warning"
              [ngClass]="{'is-loading': processing}"></span>
    }
    @default {
        <span class="timeline-point timeline-point-indicator timeline-point-secondary"
              [ngClass]="{'is-loading': processing}"></span>
    }
}